import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {objectToStr, strToObject} from './Util';

@Component({
  selector: 'app-dff-period',
  templateUrl: './dff-period.component.html',
  styleUrls: ['./dff-period.component.scss']
})
export class DffPeriodComponent extends AbstractDynamicFormFieldDirective {

  startDate: Date;
  endDate: Date;

  validate(value: string): string[] {
    if (
      this.startDate && this.endDate
      && this.startDate.getTime() > this.endDate.getTime()
    ) {
      return ['validate_period_not_valid'];
    }
    return [];
  }

  writeValue(value: string) {
    const {startDate, endDate} = strToObject(value);
    this.startDate = new Date(startDate);
    this.endDate = new Date(endDate);
  }

  updateValue() {
    this.normalizeDates();
    this.changeValue(
      objectToStr({startDate: this.startDate, endDate: this.endDate})
    );
  }

  private normalizeDates() {
    this.startDate = this.normalizeDate(this.startDate);
    this.endDate = this.normalizeDate(this.endDate);
  }

  private normalizeDate(date: Date): Date {
    if (!date) {
      return date;
    }


    // 04.05.2012 - example
    const split = date.toLocaleDateString().split('.');

    return new Date(`${split[2]}-${split[1]}-${split[0]}T00:00:00Z`);

  }
}
